import React from 'react';
import ResponsiveComponent from '@components/form/ResponsiveComponent';
import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icons from '@components/layout/sidebar/icons/icons.component';
import Collapse from '@material-ui/core/Collapse';
import * as Routes from '~/router/routes'
import {Permission} from '@components/common/permission/Permission';
import {PermissionModule} from '@components/common/permission/PermissionModule';
import {PermissionModuleGroup} from '@components/common/permission/PermissionModuleGroup';
import clsx from "clsx";
import { Link } from 'react-router-dom';
import Badge from '@material-ui/core/Badge';
import {isColorShadeDark} from '~/utils/color';

const CustomLink = props => <Link {...props} />;

export class SidebarComponent extends React.Component {

    componentDidMount() {
        this.props.history.listen((location, action) => {
            let mobileSidebarWidths = ['xs', 'sm'];
            if (mobileSidebarWidths.indexOf(this.props.width) !== -1) {
                this.props.closeSidebar();
            }
        })
    }

    toggleDrawer = (open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        this.props.closeSidebar();
    };

    encodeBase64 = (value) => {
        return btoa(value);
    }

    getPaginatedURL = (route, cookieName, params) => {
        const {cookies} = this.props;
        if (cookies.get(cookieName)) {
            route += `?perPage=${cookies.get(cookieName)}${params ? '&' + params : ''}`;
        } else if (params) {
            route += `?${params}`;
        }
        return route;
    }

    sidebarItems = () => {
        const {classes, subMenu, toggleSubMenu, context: {statuses, company}, counters, location: {pathname} } = this.props;
        let url = new URL(window.location.href);
        let searchParams = url.searchParams;
        const ordersStatusId = searchParams.get('defaultStatus') || undefined;

        return <>
            <Permission
                group={'menu'}
                permission={['leads']}
            >
                <ListItem
                    className={classes.listItem}
                    button
                    component={CustomLink}
                    to={this.getPaginatedURL(Routes.LEADS_LIST, 'leads_perPage')}
                >
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.LEADS_LIST].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.SupervisorAccountOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={'Лиды'}
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.LEADS_LIST].indexOf(pathname) !== -1,
                        })}
                    />
                </ListItem>
            </Permission>

            <Permission
                group={'menu'}
                permission={['clients']}
            >
                <ListItem
                    className={classes.listItem}
                    button
                    component={CustomLink}
                    to={this.getPaginatedURL(Routes.CLIENTS_LIST, 'clients_perPage')}
                >
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.CLIENTS_LIST].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.SupervisedUserCircleOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={'Клиенты'}
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.CLIENTS_LIST].indexOf(pathname) !== -1,
                        })}
                    />
                </ListItem>
            </Permission>

            <Permission
                group={'menu'}
                permission={['order_management']}
            >
                <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('orders')}>
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.CATALOG_ORDERS, Routes.CATALOG_DELETED_ORDERS].indexOf(pathname) !== -1,
                        })}
                    >
                        <Badge
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            color="secondary"
                            variant="dot"
                            invisible={!counters.ordersChangeStatus}
                            className={classes.ordersChangeStatus}
                        >
                            <Icons.LocalMallOutlinedIcon/>
                        </Badge>
                    </ListItemIcon>
                    <ListItemText
                        primary="Заказы"
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.CATALOG_ORDERS, Routes.CATALOG_DELETED_ORDERS].indexOf(pathname) !== -1,
                        })}
                    />
                    {subMenu.orders ? <Icons.ArrowDropUpIcon/> : <Icons.ArrowDropDownIcon/>}
                </ListItem>
                <Collapse in={subMenu.orders} timeout="auto" unmountOnExit className={classes.subItemsList}>
                    <List component="div" disablePadding>
                        <Permission
                            group={'menu'}
                            permission={['order_management']}
                        >
                            <ListItem
                                button component={CustomLink}
                                to={this.getPaginatedURL(Routes.CATALOG_ORDERS, 'orders_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.CATALOG_ORDERS === pathname && !ordersStatusId,
                                })}
                            >
                                <ListItemText primary="Все заказы"/>
                            </ListItem>
                        </Permission>
                        {Object.keys(statuses).map((key) =>
                            statuses[key].show_in_menu
                                ? <Permission
                                    group={'status'}
                                    permission={statuses[key].id}
                                    key={key}
                                >
                                    <ListItem
                                        button
                                        component={CustomLink}
                                        to={this.getPaginatedURL(`${Routes.CATALOG_ORDERS}`, 'orders_perPage', `defaultStatus=${statuses[key].id}`)}
                                        style={{'--status-color': '#' + statuses[key].color}}
                                        className={clsx(classes.nested, {
                                            [classes.nested_location]: Routes.CATALOG_ORDERS === pathname && ordersStatusId == statuses[key].id,
                                        })}
                                    >
                                        {counters.orders.filter(item => item.status.id === statuses[key].id).length > 0 && statuses[key].action !== 'complete'
                                            ? <Badge
                                                max={999}
                                                badgeContent={counters.orders.filter(item => item.status.id === statuses[key].id)[0].total}
                                                color="primary"
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                style={{
                                                    '--status-color': '#' + statuses[key].color,
                                                    '--color': isColorShadeDark(statuses[key].color) ? '#ffffff' : '#212121'
                                                }}
                                            >
                                                <ListItemText primary={statuses[key].name}></ListItemText>
                                            </Badge>
                                            : <ListItemText primary={statuses[key].name}></ListItemText>
                                        }
                                    </ListItem>
                                </Permission>
                                : null
                        )}
                        <Permission
                            group={'menu'}
                            permission={['deleted_order']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.CATALOG_DELETED_ORDERS, 'deleted-orders_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.CATALOG_DELETED_ORDERS === pathname,
                                })}
                            >
                                <ListItemText primary={'Удалённые заказы'}/>
                            </ListItem>
                        </Permission>
                    </List>
                </Collapse>
            </Permission>

            <PermissionModule
                name={'pipelines'}
            >
                <Permission
                    group={'menu'}
                    permission={['pipeline']}
                >
                    <ListItem
                        className={classes.listItem}
                        button
                        component={CustomLink}
                        to={Routes.PIPELINE}
                    >
                        <ListItemIcon
                            className={clsx(classes.listItem_icon, {
                                [classes.icon_location]: [Routes.PIPELINE].indexOf(pathname) !== -1,
                            })}
                        >
                            <Icons.BlurLinearOutlinedIcon/>
                        </ListItemIcon>
                        <ListItemText
                            primary={'Пайплайны'}
                            className={clsx(classes.listItem_text, {
                                [classes.text_location]: [Routes.PIPELINE].indexOf(pathname) !== -1,
                            })}
                        />
                    </ListItem>
                </Permission>
            </PermissionModule>

            <PermissionModule
                name={'chatbots'}
            >
                <Permission
                    group={'menu'}
                    permission={['chat']}
                >
                    <ListItem
                        className={classes.listItem}
                        button
                        component={CustomLink}
                        to={Routes.CHAT}
                    >
                        <ListItemIcon
                            className={clsx(classes.listItem_icon, {
                                [classes.icon_location]: [Routes.CHAT].indexOf(pathname) !== -1,
                            })}
                        >
                            <Badge
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                color="secondary"
                                badgeContent={counters.chats}
                                max={999}
                                invisible={!counters.chats}
                            >
                                <Icons.ForumOutlinedIcon/>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText
                            primary={'Чат-бот'}
                            className={clsx(classes.listItem_text, {
                                [classes.text_location]: [Routes.CHAT].indexOf(pathname) !== -1,
                            })}
                        />
                    </ListItem>
                </Permission>
            </PermissionModule>

            <Permission
                group={'menu'}
                permission={['user_tasks']}
            >
                <ListItem
                    className={classes.listItem}
                    button
                    component={CustomLink} to={Routes.USER_TASKS}
                >
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.USER_TASKS].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.AssignmentIndOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={'Задачи сотрудников'}
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.USER_TASKS].indexOf(pathname) !== -1,
                        })}
                    />
                </ListItem>
            </Permission>

            <Permission
                group={'menu'}
                permission={['scansheets']}
            >
                {company.settings.product_packaging ? <>
                    <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('scansheets')}>
                        <ListItemIcon
                            className={clsx(classes.listItem_icon, {
                                [classes.icon_location]: [Routes.SCANSHEET_ORDERS_LIST, Routes.SCANSHEET_PRODUCTS_LIST].indexOf(pathname) !== -1,
                            })}
                        >
                            <Icons.BallotOutlinedIcon/>
                        </ListItemIcon>
                        <ListItemText
                            primary="Упаковка"
                            className={clsx(classes.listItem_text, {
                                [classes.text_location]: [Routes.SCANSHEET_ORDERS_LIST, Routes.SCANSHEET_PRODUCTS_LIST].indexOf(pathname) !== -1,
                            })}
                        />
                        {subMenu.scansheets ? <Icons.ArrowDropUpIcon/> : <Icons.ArrowDropDownIcon/>}
                    </ListItem>
                    <Collapse in={subMenu.scansheets} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding className={classes.subItemsList}>
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.SCANSHEET_ORDERS_LIST, 'scansheets_orders_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SCANSHEET_ORDERS_LIST === pathname,
                                })}
                            >
                                <ListItemText primary="Заказы"/>
                            </ListItem>
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.SCANSHEET_PRODUCTS_LIST, 'scansheets_products_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SCANSHEET_PRODUCTS_LIST === pathname,
                                })}
                            >
                                <ListItemText primary="Товары"/>
                            </ListItem>
                        </List>
                    </Collapse>
                </> : null}
            </Permission>

            <Permission
                group={'menu'}
                permission={['warehouse_suppliers']}
            >
                <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('warehouse')}>
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.WAREHOUSE_SUPPLIERS].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.StoreOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary="Cклад"
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.WAREHOUSE_SUPPLIERS].indexOf(pathname) !== -1,
                        })}
                    />
                    {subMenu.warehouse ? <Icons.ArrowDropUpIcon/> : <Icons.ArrowDropDownIcon/>}
                </ListItem>
                <Collapse in={subMenu.warehouse} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding className={classes.subItemsList}>
                        <Permission
                            group={'menu'}
                            permission={['warehouse_suppliers']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.WAREHOUSE_SUPPLIERS, 'suppliers_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.WAREHOUSE_SUPPLIERS === pathname,
                                })}
                            >
                                <ListItemText primary="Поставщики"/>
                            </ListItem>
                        </Permission>
                    </List>
                </Collapse>
            </Permission>

            <Permission
                group={'menu'}
                permission={['product_management', 'product_characteristic_group', 'product_category', 'characteristics', 'showcase_visibility']}
            >
                <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('catalog')}>
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.CATALOG_CATEGORIES, Routes.CATALOG_CHARACTERISTIC_GROUPS, Routes.CATALOG_CHARACTERISTICS, Routes.CATALOG_PRODUCTS].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.ListOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary="Каталог"
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.CATALOG_CATEGORIES, Routes.CATALOG_CHARACTERISTIC_GROUPS, Routes.CATALOG_CHARACTERISTICS, Routes.CATALOG_PRODUCTS].indexOf(pathname) !== -1,
                        })}
                    />
                    {subMenu.catalog ? <Icons.ArrowDropUpIcon /> : <Icons.ArrowDropDownIcon />}
                </ListItem>
                <Collapse in={subMenu.catalog} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding className={classes.subItemsList}>
                        <Permission
                            group={'menu'}
                            permission={['product_category']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.CATALOG_CATEGORIES, 'categories_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.CATALOG_CATEGORIES === pathname,
                                })}
                            >
                                <ListItemText primary="Категории товаров"/>
                            </ListItem>
                        </Permission>

                        <Permission
                            group={'menu'}
                            permission={['product_characteristic_group']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.CATALOG_CHARACTERISTIC_GROUPS, 'characteristic-groups_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.CATALOG_CHARACTERISTIC_GROUPS === pathname,
                                })}
                            >
                                <ListItemText primary="Категории характеристик"/>
                            </ListItem>
                        </Permission>

                        <Permission
                            group={'menu'}
                            permission={['characteristics']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.CATALOG_CHARACTERISTICS, 'characteristics_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.CATALOG_CHARACTERISTICS === pathname,
                                })}
                            >
                                <ListItemText primary="Характеристики"/>
                            </ListItem>
                        </Permission>

                        <Permission
                            group={'menu'}
                            permission={['product_management']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.CATALOG_PRODUCTS, 'products_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.CATALOG_PRODUCTS === pathname,
                                })}
                            >
                                <ListItemText primary="Товары"/>
                            </ListItem>
                        </Permission>

                        <PermissionModule
                            name={'showcase'}
                        >
                            <Permission
                                group={'menu'}
                                permission={['showcase_visibility']}
                            >
                                <ListItem
                                    button
                                    component={CustomLink}
                                    to={this.getPaginatedURL(Routes.PRODUCTS_SHOWCASE_ROOT + this.encodeBase64(this.props.context.company.id), 'products-showcase_perPage')}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.open(this.getPaginatedURL(Routes.PRODUCTS_SHOWCASE_ROOT + this.encodeBase64(this.props.context.company.id), 'products-showcase_perPage'), '_blank')
                                    }}
                                    className={classes.nested}
                                >
                                    <ListItemText primary="Витрина товаров"/>
                                </ListItem>
                            </Permission>
                        </PermissionModule>
                    </List>
                </Collapse>
            </Permission>

            <Permission
                group={'menu'}
                permission={['marketing_costs' , 'marketing']}
            >
                <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('marketing')}>
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.MARKETING_COSTS, Routes.MARKETING].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.RecordVoiceOverOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary="Маркетинг"
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.MARKETING_COSTS, Routes.MARKETING].indexOf(pathname) !== -1,
                        })}
                    />
                    {subMenu.marketing ? <Icons.ArrowDropUpIcon/> : <Icons.ArrowDropDownIcon/>}
                </ListItem>
                <Collapse in={subMenu.marketing} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding className={classes.subItemsList}>
                        <Permission
                            group={'menu'}
                            permission={['marketing_costs']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={Routes.MARKETING_COSTS}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.MARKETING_COSTS === pathname,
                                })}
                            >
                                <ListItemText primary="Настройка стоимости"/>
                            </ListItem>
                        </Permission>
                        <PermissionModule
                            name={'turbosms'}
                        >
                            <Permission
                                group={'menu'}
                                permission={['marketing']}
                            >
                                <ListItem
                                    button
                                    component={CustomLink}
                                    to={Routes.MARKETING}
                                    className={clsx(classes.nested, {
                                        [classes.nested_location]: Routes.MARKETING === pathname,
                                    })}
                                >
                                    <ListItemText primary={'Рассылки'}/>
                                </ListItem>
                            </Permission>
                        </PermissionModule>
                    </List>
                </Collapse>
            </Permission>

            <Permission
                group={'menu'}
                permission={['analytics', 'analytics_orders_prime_cost', 'analytics_calls', 'nps', 'company_activity']}
            >
                <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('analytics')}>
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.REPORT, Routes.REPORT_ORDERS_PRIME_COST, Routes.REPORT_CALLS, Routes.NPS_ANALYTICS, Routes.COMPANY_ACTIVITY].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.AssessmentOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary="Аналитика"
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.REPORT, Routes.REPORT_ORDERS_PRIME_COST, Routes.REPORT_CALLS, Routes.NPS_ANALYTICS, Routes.COMPANY_ACTIVITY].indexOf(pathname) !== -1,
                        })}
                    />
                    {subMenu.analytics ? <Icons.ArrowDropUpIcon/> : <Icons.ArrowDropDownIcon/>}
                </ListItem>
                <Collapse in={subMenu.analytics} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding className={classes.subItemsList}>
                        <Permission
                            group={'menu'}
                            permission={['analytics']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={Routes.REPORT}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.REPORT === pathname,
                                })}
                            >
                                <ListItemText primary="Финансовая аналитика"/>
                            </ListItem>
                        </Permission>
                        <Permission
                            group={'menu'}
                            permission={['analytics_orders_prime_cost']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={Routes.REPORT_ORDERS_PRIME_COST}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.REPORT_ORDERS_PRIME_COST === pathname,
                                })}
                            >
                                <ListItemText primary="Себестоимость заказов"/>
                            </ListItem>
                        </Permission>
                        <Permission
                            group={'menu'}
                            permission={['analytics_calls']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={Routes.REPORT_CALLS}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.REPORT_CALLS === pathname,
                                })}
                            >
                                <ListItemText primary="Звонки"/>
                            </ListItem>
                        </Permission>
                        <PermissionModule
                            name={'nps'}
                        >
                            <Permission
                                group={'menu'}
                                permission={['nps']}
                            >
                                <ListItem
                                    button
                                    component={CustomLink}
                                    to={Routes.NPS_ANALYTICS}
                                    className={clsx(classes.nested, {
                                        [classes.nested_location]: Routes.NPS_ANALYTICS === pathname,
                                    })}
                                >
                                    <ListItemText primary="NPS"/>
                                </ListItem>
                            </Permission>
                        </PermissionModule>
                        <Permission
                            group={'menu'}
                            permission={['company_activity']}
                        >
                            <ListItem
                                className={classes.listItem}
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.COMPANY_ACTIVITY, 'company-activity_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.COMPANY_ACTIVITY === pathname,
                                })}
                            >
                                <ListItemText
                                    primary={'Действия сотрудников'}
                                />
                            </ListItem>
                        </Permission>
                    </List>
                </Collapse>
            </Permission>

            <Permission
                group={'menu'}
                permission={[
                    'user_management',
                    'dropshipper_management',
                    'business_processes',
                    'order_status_management',
                    'marketing_channels_management',
                    'currency',
                    'product_price_group',
                    'messages_template',
                    'user_tasks_timetable'
                ]}
            >
                <ListItem className={classes.listItem} button onClick={(e) => toggleSubMenu('settings')}>
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.SETTINGS_BUSINESS_PROCESSES, Routes.SETTINGS_ORDER_STATUSES, Routes.SETTINGS_UTM, Routes.SETTINGS_CURRENCIES, Routes.SETTINGS_PRODUCT_PRICE_GROUP, Routes.SETTINGS_MESSAGES_TEMPLATES, Routes.PROFILE, Routes.USERS_LIST, Routes.DROPSHIPPERS_LIST, Routes.USER_TASKS_TIMETABLE].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.SettingsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary="Настройки"
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.SETTINGS_BUSINESS_PROCESSES, Routes.SETTINGS_ORDER_STATUSES, Routes.SETTINGS_UTM, Routes.SETTINGS_CURRENCIES, Routes.SETTINGS_PRODUCT_PRICE_GROUP, Routes.SETTINGS_MESSAGES_TEMPLATES, Routes.PROFILE, Routes.USERS_LIST, Routes.DROPSHIPPERS_LIST, Routes.USER_TASKS_TIMETABLE].indexOf(pathname) !== -1,
                        })}
                    />
                    {subMenu.settings ? <Icons.ArrowDropUpIcon /> : <Icons.ArrowDropDownIcon />}
                </ListItem>
                <Collapse in={subMenu.settings} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding className={classes.subItemsList}>
                        <ListItem
                            button
                            component={CustomLink}
                            to={Routes.PROFILE}
                            className={clsx(classes.nested, {
                                [classes.nested_location]: Routes.PROFILE === pathname,
                            })}
                        >
                            <ListItemText primary="Профиль"/>
                        </ListItem>

                        <Permission
                            group={'menu'}
                            permission={['user_management']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.USERS_LIST, 'users_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.USERS_LIST === pathname,
                                })}
                            >
                                <ListItemText primary="Сотрудники"/>
                            </ListItem>
                        </Permission>

                        <PermissionModule
                            name={'dropshipper'}
                        >
                            <Permission
                                group={'menu'}
                                permission={['dropshipper_management']}
                            >
                                <ListItem
                                    button
                                    component={CustomLink}
                                    to={this.getPaginatedURL(Routes.DROPSHIPPERS_LIST, 'dropshippers_perPage')}
                                    className={clsx(classes.nested, {
                                        [classes.nested_location]: Routes.DROPSHIPPERS_LIST === pathname,
                                    })}
                                >
                                    <ListItemText primary="Дропшиппинг"/>
                                </ListItem>
                            </Permission>
                        </PermissionModule>
                        <Permission
                            group={'menu'}
                            permission={['business_processes']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={Routes.SETTINGS_BUSINESS_PROCESSES}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SETTINGS_BUSINESS_PROCESSES === pathname,
                                })}
                            >
                                <ListItemText primary="Бизнес-процессы"/>
                            </ListItem>
                        </Permission>
                        <Permission
                            group={'menu'}
                            permission={['order_status_management']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.SETTINGS_ORDER_STATUSES, 'order-statuses_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SETTINGS_ORDER_STATUSES === pathname,
                                })}
                            >
                                <ListItemText primary="Статусы"/>
                            </ListItem>
                        </Permission>
                        <Permission
                            group={'menu'}
                            permission={['marketing_channels_management']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.SETTINGS_UTM, 'utm_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SETTINGS_UTM === pathname,
                                })}
                            >
                                <ListItemText primary="UTM метки"/>
                            </ListItem>
                        </Permission>
                        <Permission
                            group={'menu'}
                            permission={['currency']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.SETTINGS_CURRENCIES, 'currencies_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SETTINGS_CURRENCIES === pathname,
                                })}
                            >
                                <ListItemText primary="Валюты"/>
                            </ListItem>
                        </Permission>
                        <Permission
                            group={'menu'}
                            permission={['product_price_group']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.SETTINGS_PRODUCT_PRICE_GROUP, 'product-price-group_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.SETTINGS_PRODUCT_PRICE_GROUP === pathname,
                                })}
                            >
                                <ListItemText primary="Группы цен"/>
                            </ListItem>
                        </Permission>
                        <PermissionModuleGroup
                            type={'sms'}
                        >
                            <Permission
                                group={'menu'}
                                permission={['messages_templates']}
                            >
                                <ListItem
                                    button
                                    component={CustomLink}
                                    to={Routes.SETTINGS_MESSAGES_TEMPLATES}
                                    className={clsx(classes.nested, {
                                        [classes.nested_location]: Routes.SETTINGS_MESSAGES_TEMPLATES === pathname,
                                    })}
                                >
                                    <ListItemText primary={'Шаблоны СМС'}/>
                                </ListItem>
                            </Permission>
                        </PermissionModuleGroup>
                        <Permission
                            group={'menu'}
                            permission={['user_tasks_timetable']}
                        >
                            <ListItem
                                button
                                component={CustomLink}
                                to={this.getPaginatedURL(Routes.USER_TASKS_TIMETABLE, 'user_tasks_timetable_perPage')}
                                className={clsx(classes.nested, {
                                    [classes.nested_location]: Routes.USER_TASKS_TIMETABLE === pathname,
                                })}
                            >
                                <ListItemText primary="Расписание задач"/>
                            </ListItem>
                        </Permission>
                    </List>
                </Collapse>
            </Permission>

            <PermissionModuleGroup
                type={'bank'}
            >
                <Permission
                    group={'menu'}
                    permission={['bank_transactions']}
                >
                    <ListItem
                        className={classes.listItem}
                        button component={CustomLink}
                        to={this.getPaginatedURL(Routes.FINANCES_BANK_TRANSACTIONS_LIST, 'finances_transactions_perPage')}
                    >
                        <ListItemIcon
                            className={clsx(classes.listItem_icon, {
                                [classes.icon_location]: [Routes.FINANCES_BANK_TRANSACTIONS_LIST].indexOf(pathname) !== -1,
                            })}
                        >
                            <Icons.LocalAtmOutlinedIcon/>
                        </ListItemIcon>
                        <ListItemText
                            primary={'Банковские выписки'}
                            className={clsx(classes.listItem_text, {
                                [classes.text_location]: [Routes.FINANCES_BANK_TRANSACTIONS_LIST].indexOf(pathname) !== -1,
                            })}
                        />
                    </ListItem>
                </Permission>
            </PermissionModuleGroup>

            <Permission
                group={'menu'}
                permission={['module_management']}
            >
                <ListItem
                    className={classes.listItem}
                    button component={CustomLink}
                    to={Routes.MODULE_MANAGEMENT_LIST}
                >
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.MODULE_MANAGEMENT_LIST].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.ViewModuleOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={'Модули'}
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.MODULE_MANAGEMENT_LIST].indexOf(pathname) !== -1,
                        })}
                    />
                </ListItem>
            </Permission>

            <Permission
                group={'menu'}
                permission={['billing']}
            >
                <ListItem
                    className={classes.listItem}
                    button
                    component={CustomLink}
                    to={this.getPaginatedURL(Routes.INVOICE_LIST, 'invoice_perPage')}
                >
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.INVOICE_LIST].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.PaymentOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={'Биллинг'}
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.INVOICE_LIST].indexOf(pathname) !== -1,
                        })}
                    />
                </ListItem>
            </Permission>

            <Permission
                group={'menu'}
                permission={['system_actions']}
            >
                <ListItem
                    className={classes.listItem}
                    button
                    component={CustomLink}
                    to={this.getPaginatedURL(Routes.SYSTEM_ACTIONS, 'system-activity_perPage')}
                >
                    <ListItemIcon
                        className={clsx(classes.listItem_icon, {
                            [classes.icon_location]: [Routes.SYSTEM_ACTIONS].indexOf(pathname) !== -1,
                        })}
                    >
                        <Icons.HistoryIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={'Системные действия'}
                        className={clsx(classes.listItem_text, {
                            [classes.text_location]: [Routes.SYSTEM_ACTIONS].indexOf(pathname) !== -1,
                        })}
                    />
                </ListItem>
            </Permission>

            <Divider />

            <ListItem
                className={classes.listItem}
                button
                component={CustomLink}
                to={Routes.CUSTOMER_DEVELOPMENT}
            >

                <ListItemIcon
                    className={clsx(classes.listItem_icon, {
                        [classes.icon_location]: [Routes.CUSTOMER_DEVELOPMENT].indexOf(pathname) !== -1,
                    })}
                >
                    <Badge
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        color="secondary"
                        variant="dot"
                        invisible={window.app.version === this.props.cookies.get('version')}
                        className={classes.ordersChangeStatus}
                    >
                        <Icons.DeveloperBoardOutlinedIcon/>
                    </Badge>
                </ListItemIcon>
                <ListItemText
                    className={clsx(classes.listItem_text, {
                        [classes.text_location]: [Routes.CUSTOMER_DEVELOPMENT].indexOf(pathname) !== -1,
                    })}
                    primary={'Разработка'}
                />
            </ListItem>

            <ListItem className={classes.listItem} button onClick={() => window.location = Routes.LOGOUT}>
                <ListItemIcon className={classes.listItem_icon}><Icons.ExitToAppOutlinedIcon/></ListItemIcon>
                <ListItemText className={classes.listItem_text} primary={'Выход'}/>
            </ListItem>
        </>
    }

    render() {
        const {classes} = this.props;
        let {permissions = {}} = this.props.context;
        let open = this.props.isOpened || this.props.isHover;
        return (<>
            {Object.keys(permissions).length !== 0 && <ResponsiveComponent
                xs={<SwipeableDrawer
                    anchor={'left'}
                    variant="temporary"
                    onOpen={this.props.openSidebar}
                    open={open}
                    onClose={this.toggleDrawer()}
                    PaperProps={{
                        style: {background: '#f5f5f5'}
                    }}
                >
                    <div
                        className={classes.list}
                        role="presentation"
                    >
                        {this.sidebarItems()}
                    </div>
                </SwipeableDrawer>}
                md={<Drawer
                    onMouseOver={e => !this.props.isHover && (!this.props.isOpened ? this.props.onMouseOverSidebar() : this.props.onMouseOverOpenedSidebar())}
                    onMouseLeave={e => this.props.isHover && (!this.props.isOpened ? this.props.onMouseLeaveSidebar() : this.props.onMouseLeaveOpenedSidebar())}
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div
                        className={classes.list}
                        role="presentation"
                    >
                        <div className={classes.toolbar} />
                        <Divider/>
                        {this.sidebarItems()}
                    </div>
                </Drawer>}
            />}
        </>)
    }
}
